import React from 'react';
import { BadgeCheck } from 'lucide-react';

export const VerifiedBadge = ({ size = 16, className = '' }) => (
  <BadgeCheck
    size={size}
    className={`text-[hsl(205,100%,56%)] shrink-0 ${className}`}
    fill="hsl(205 100% 56% / 0.2)"
    data-testid="profile-verification-badge"
  />
);
